<template>
	<div id="down-main-page">
		<div class="top_part">
			<img v-if="$i18n.locale == 'zh'" class="top_part_back" src="@/assets/download/newback.png" alt="">
			<img v-else-if="$i18n.locale == 'zh-HK' || $i18n.locale == 'zh-TW' || $i18n.locale == 'zh-h'"
				class="top_part_back" src="@/assets/download/newback2.png" alt="">
			<img v-else class="top_part_back" src="@/assets/download/newback3.png" alt="">
			<!-- <img class="top_logo" src="@/assets/download/back-logo.png" alt=""> -->
			<h1 :class="$i18n.locale">{{ $t('down.grid_bot') }}</h1>
			<h2 :class="$i18n.locale">{{ $t('down.overcome_emotional') }}<br />{{ $t('down.fortune_market') }}</h2>
		</div>
		<!-- <div class="contact">*iOS用户需用海外Apple ID下载，</div> -->
		<!-- <div>翻译测试{{$t("message.hello_world")}}</div> -->
		<div class="contact mb-117">
			<span>{{ $t('down.contact_email') }}:{{ email }}</span>
			<span class="copy my_code" @click="copy">
				<img src="@/assets/download/copy.png">
			</span>
		</div>
		<div class="button_box">
			<!-- <button @click="iosProDown('ewm')">
			    <div class="ove">
			    	<img src="@/assets/download/apple.png" alt="">
			    	<div class="r">
			    		<span>Distribution <span class="min">({{$t('down.recommend')}})</span></span>
						<span class="little">({{$t('down.enterprise')}})</span>
			    		<span class="little">({{$t('down.overseas')}}ID)</span>
			    	</div>
			    </div>
			</button> -->

			<button @click="iosProDown">
				<div class="ove">
					<img src="@/assets/download/apple.png" alt="">
					<div class="r">
						<span>Testflight <span class="min">({{$t('down.recommend')}})</span></span>
						<!-- <span class="little">({{$t('down.overseas')}}ID)</span> -->
					</div>
				</div>
			</button>

			<button @click="iosProDown('store')">
				<div class="ove">
					<img src="@/assets/download/apple.png" alt="">
					<div class="r">
						<span>Appstore
							<span v-if="$i18n.locale == 'zh' || $i18n.locale == 'zh-h'" class="min">(蘋果)</span>
						</span>
						<span class="little">({{$t('down.overseas')}}ID)</span>
					</div>
				</div>
			</button>

			<button @click="androidDown">
				<div class="ove">
					<img src="@/assets/download/and.png" alt="">
					<div class="r">
						<span class="size-16">Android
							<span v-if="$i18n.locale == 'zh' || $i18n.locale == 'zh-h'" class="min">(安卓)</span>
						</span>
					</div>
				</div>
			</button>
			<div class="h2" @click="linkClick">{{$t('down.register_guide')}}</div>
		</div>
		<div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
			<span class="mask-tip">{{ $t('common.open_in_browser') }}</span>
			<img src="@/assets/down/tip_arrow.png" />
		</div>
		<jgz-loading :loading-show='showLoading'></jgz-loading>
		<div class="alert" v-show="alertShow">
			<span>{{message}}</span>
		</div>
	</div>
</template>

<script>
	import JgzLoading from '@/components/JgzLoading.vue'
	import Clipboard from 'clipboard'
	export default {
		name: 'Download',
		data() {
			return {
				maskViewShow: false,
				iosUrl: '',
				androidUrl: '',
				alertShow: false,
				message: '',
				email: 'jinguozi007@gmail.com',
				showLoading: true,
			}
		},
		components: {
			JgzLoading,
		},
		mounted() {
			// const script = document.createElement('script')
			// script.src = 'https://s9.cnzz.com/z_stat.php?id=1278708975&web_id=1278708975'
			// script.language = 'JavaScript'
			// document.body.appendChild(script)
			this.getDownUrl();
			// console.log( 111, this.$i18n.locale )

			// //判斷ip地址
			// let resData = '';
			// this.$MyAxios.get( `/api/accounts/ipAddr`, res => {
			// 	resData = res.data
			// 	// 1：中国大陆，2：中国香港，3：中国台湾，4：国外
			// 	if ( resData.areaCode == 1 ) {
			// 		this.$router.push( {
			// 			name: 'cannotAccess'
			// 		} )
			// 	}
			// }, err => {
			// 	resData = err.data
			// 	// 1：中国大陆，2：中国香港，3：中国台湾，4：国外
			// 	if ( resData.areaCode == 1 ) {
			// 		this.$router.push( {
			// 			name: 'cannotAccess'
			// 		} )
			// 	}
			// } )
		},
		watch: {
			$route() {
				if (window._czc) {
					let location = window.location
					let contentUrl = location.pathname + location.hash
					let refererUrl = '/'
					window._czc.push(['_trackPageview', contentUrl, refererUrl])
				}
			}
		},
		methods: {
			linkClick() {
				let locale = this.$i18n.locale
				let id = ''
				//判断跳转英文还是中文
				if (locale == 'zh') {
					id = '100062'
				} else if (locale == 'zh-HK' || locale == 'zh-TW' || locale == 'zh-h') {
					id = '100063'
				} else if (locale == 'en') {
					id = '100064'
				}
				window.open('https://www.jgz.com/#/pages/materials/detail/detail?id=' + id)
			},

			copy() {
				let str = this.email
				let clipboard = new Clipboard('.my_code', {
					text: function() {
						return str
					}
				})
				console.log(clipboard)
				clipboard.on('success', e => {
					this.showAlert(this.$t('down.copy_success'))
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					this.showAlert(this.$t('down.copy_failed') + this.$t('down.press_copy'))
					clipboard.destroy()
				})
			},
			showAlert(message) {
				this.message = message;
				this.alertShow = true;
				setTimeout(() => {
					this.alertShow = false;
				}, 1500);
			},

			getDownUrl() {
				this.$MyAxios.get('/api/versions/downloadUrl', {}, response => {
					if (response.code == 1) {
						this.showLoading = false;
						this.iosUrl = response.data.ios;
						this.androidUrl = response.data.android;
					}
				})
			},


			// 安卓交易版本下载
			androidDown() {
				let isWeChat = /MicroMessenger/.test(navigator.userAgent);
				if (isWeChat) {
					this.maskViewShow = true;
				} else {
					if (window._czc) {
						window._czc.push(['_trackEvent', 'APP下载', '安卓下载'])
					}
					var iframe = document.createElement('iframe');
					iframe.style.display = 'none';
					iframe.src = "javascript: '<script>location.href=\"" + this.androidUrl + "\"<\/script>'";
					// let url = "https://test.misc.jinguozi.net/JGZ.apk"                          //  交易版URL
					// iframe.src = "javascript: '<script>location.href=\"" + url + "\"<\/script>'";
					document.getElementsByTagName('body')[0].appendChild(iframe);
					console.log(666, iframe.src)
				}
			},

			//  testflight普通版本下载
			iosDown() {
				let isWeChat = /MicroMessenger/.test(navigator.userAgent);
				if (isWeChat) {
					this.maskViewShow = true;
				} else {
					// window.location.href = 'itms-services://?action=download-manifest&url=https://down.jgz.com/mainifest.plist';
					window.location.href = `http://www.ggsign123.com/app_merge/jinguozi`;
				}
			},

			//  testflight交易版本下载
			iosProDown(tag) {
				// return
				let isWeChat = /MicroMessenger/.test(navigator.userAgent);
				if (isWeChat) {
					this.maskViewShow = true;
				} else {
					// window.location.href = `https://testflight.apple.com/join/TO7aMQTq`;
					// window.location.href = this.iosUrl;
					if (tag === 'store') {
						window.open('https://apps.apple.com/hk/app/jgzquant-crypto-trading-bot/id6446046065')
					} else if (tag == 'ewm') {
						window.location.href = 'https://lmybc.ekfhdzid.com/api/c/3uiafh36' //https://1.aichu2.top/ouoTBe
					} else {
						window.location.href = this.iosUrl;
					}
				}
			},

			//  本地服务器版本下载
			iosServerDown() {
				let isWeChat = /MicroMessenger/.test(navigator.userAgent);
				if (isWeChat) {
					this.maskViewShow = true;
				} else {
					window.location.href = `itms-services://?action=download-manifest&url=${this.iosUrl}`;
				}
			},
		}
	}
</script>

<style lang='less'>
	#down-main-page {
		min-height: 100vh;
		width: 100%;
		background: linear-gradient(180deg, #fff6e8, #ffffff);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;

		img {
			pointer-events: none;
		}

		.top_part {
			width: 100%;
			height: 654px;
			// margin-bottom: 80px;
			margin-bottom: 60px;

			.top_part_back {
				width: 100%;
				height: 654px;
				position: relative;
				overflow: hidden;
			}

			.top_logo {
				height: 163px;
				width: 306px;
				left: 26px;
				top: 84px;
				position: absolute;
				z-index: 1;
			}

			h1 {
				height: 68px;
				width: 360px;
				line-height: 71px;
				font-size: 48px;
				font-weight: 600;
				color: #ffffff;
				position: absolute;
				top: 240px;
				left: 57px;
				text-align: left;

				&.en {
					font-size: 40px;
					line-height: 42px;
				}
			}

			h2 {
				height: 118px;
				width: 355px;
				line-height: 62px;
				font-size: 40px;
				font-weight: 400;
				color: #ffffff;
				position: absolute;
				top: 300px;
				left: 57px;
				text-align: left;

				&.en {
					font-size: 28px;
					line-height: 38px;
					top: 360px;
				}
			}
		}

		.contact {
			font-size: 28px;
			margin-bottom: 20px;
			line-height: 40px;

			&.mb-117 {
				margin-bottom: 77px;
			}

			span {
				vertical-align: middle;
				margin-right: 20px;
			}

			img {
				vertical-align: middle;
				width: 40px;
				height: 40px;
			}
		}

		.button_box {
			position: relative;

			.h2 {
				font-size: 28px;
				color: #191929;
				cursor: pointer;
			}
		}

		button {
			height: 88px;
			width: 80vw;
			outline: none;
			border: none;
			cursor: pointer;
			border-radius: 8px;
			background: #FF811F;
			margin-bottom: 40px;
			color: #ffffff;
			font-size: 32px;
			font-weight: bold;
			align-items: center;
			justify-content: center;
			display: flex;
			margin-left: 10vw;

			&.disable {
				background: gray;
			}

			.ove {
				overflow: hidden;
				align-items: center;
				display: flex;

				img {
					float: left;
					width: 48px;
					height: 48px;
					margin-right: 20px;
				}

				.r {
					float: left;
				}

				.min {
					display: inline-block;
					font-size: 24px;
				}

				span {
					text-align: center;
					display: block;
					font-size: 28px;
					font-weight: 400;
				}

				.little {
					font-size: 20px;
				}

				.size-16 {
					font-size: 32px;
				}
			}

		}

		.alert {
			position: fixed;
			z-index: 3;
			top: 40%;
			left: 50%;
			height: 60px;
			width: auto;
			padding: 0 30px;
			transform: translateX(-100px);
			border-radius: 8px;
			background: rgba(0, 0, 0, .9);
			color: #ffffff;
			line-height: 60px;
		}
	}

	@keyframes moveLeft {
		0% {
			left: 0vw;
		}

		50% {
			left: -200vw;
		}

		100% {
			left: 0vw;
		}
	}

	@-webkit-keyframes moveLeft

	/*Safari and Chrome*/
		{
		0% {
			left: 0vw;
		}

		50% {
			left: -200vw;
		}

		100% {
			left: 0vw;
		}
	}

	@keyframes moveRight {
		from {
			left: -200vw;
		}

		to {
			left: 0px;
		}
	}

	@-webkit-keyframes moveRight

	/*Safari and Chrome*/
		{
		from {
			left: -200vw;
		}

		to {
			left: 0px;
		}
	}
</style>